<template>
    <div class="print-header">
        <img class="logo" src="/static/svg/chloe_logo_black.svg" alt="logo" />
        <div class="user">
            <div class="detail">
                <div class="user-name">{{ user.firstName }} {{ user.lastName }}</div>
                <div>{{ tenant.name }}</div>
            </div>
            <div class="image">
                <b-avatar :src="avatarUrl" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
    name: 'PrintHeader',
    computed: {
        ...mapGetters({
            tenant: 'common/getTenant',
            avatarUrl: 'common/getAvatarUrl'
        }),
        ...mapState({
            user: state => state.common.user
        })
    }
}
</script>
<style lang="scss" scoped>
.print-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
        height: 40px;
    }
    .user {
        display: flex;
        text-align: right;
        gap: 15px;
        align-items: center;

        .user-name {
            font-weight: bold;
            text-transform: capitalize;
        }
    }
}
</style>
